require('./bootstrap');

// Close flash alert automatically
window.setTimeout(function () {
  $('.alert.alert-dismissible').alert('close');
}, 3000);

// Datetime picker
global.moment = require('moment');
require('moment/locale/ja');
require('tempusdominus-bootstrap-4');

// Cookie
global.Cookies = require('js-cookie');

$(function () {
  // ポップオーバー
  $('[data-toggle="popover"]').popover();

  $('.datepicker').datetimepicker({
    dayViewHeaderFormat: 'YYYY年 M月',
    format: 'YYYY-MM-DD',
    locale: 'ja',
    icons: {
      time: '',
      date: '',
      up: '',
      down: 'fas fa-arrow-down',
      previous: 'fas fa-caret-left',
      next: 'fas fa-caret-right',
      today: '',
      clear: '',
      close: ''
    }
  });

  // タブの代わりにセレクトボックスを表示した際、その選択をタブに連動させる
  $('.select-nav').on('change', function(e) {
    var id = $(this).val();
    $('a[href="' + id + '"]').tab('show');
  });

  // テキストエリアの高さを自動的に調整する
  $('textarea').on('input', function () {
    this.style.height = 'auto';

    // this.scrollHeightと同じ高さにするとスクロールバーが出ることがあるため微小な数値(暫定で2)を加算
    this.style.height = (this.scrollHeight + 2) + 'px';
  });

  /**
   * HTML5のform属性に対応するためのPolyfill（IE11対応）
   */

  // Detect if browser supports this
  var sampleElement = $('[form]').get(0);
  var isIE11 = !(window.ActiveXObject) && "ActiveXObject" in window;
  if (sampleElement && window.HTMLFormElement && (sampleElement.form instanceof HTMLFormElement || sampleElement instanceof window.HTMLFormElement) && !isIE11) {
    // browser supports it, no need to fix
    return;
  }

  // Append a field to a form
  $.fn.appendField = function (data) {
    // for form only
    if (!this.is('form')) return;

    // wrap data
    if (!$.isArray(data) && data.name && data.value) {
      data = [data];
    }

    var $form = this;

    // attach new params
    $.each(data, function (i, item) {
      $('<input/>')
        .attr('type', 'hidden')
        .attr('name', item.name)
        .val(item.value).appendTo($form);
    });

    return $form;
  };

  // Find all input fields with form attribute point to jQuery object
  $('form[id]').submit(function (e) {
    // serialize data
    var data = $('[form=' + this.id + ']').serializeArray();
    // append data to form
    $(this).appendField(data);
  }).each(function () {
    var form = this,
      $fields = $('[form=' + this.id + ']');

    $fields.filter('button, input').filter('[type=reset],[type=submit]').click(function () {
      var type = this.type.toLowerCase();
      if (type === 'reset') {
        // reset form
        form.reset();
        // for elements outside form
        $fields.each(function () {
          this.value = this.defaultValue;
          this.checked = this.defaultChecked;
        }).filter('select').each(function () {
          $(this).find('option').each(function () {
            this.selected = this.defaultSelected;
          });
        });
      } else if (type.match(/^submit|image$/i)) {
        $(form).appendField({name: this.name, value: this.value}).submit();
      }
    });
  });
});

$.ajaxSetup({
  headers: {
    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
  }
});

window.Vue = require('vue');

/**
 * 多言語化対応用セッティング
 */
import { createI18n } from 'vue-i18n';
const i18n = createI18n({
  locale: 'ja', // set locale
  messages: {
    ja: require('../lang/ja.json'),
    zh: require('../lang/zh.json'),
    en: require('../lang/en.json'),
    'ja-carecareer': require('../lang/ja-carecareer.json'),
  },
  silentTranslationWarn: true
});

/**
 * 言語を取得
 *
 * @returns {string|*|jQuery|string}
 */
const getCurrentLocale = () => {
  const locale = $('#locale').val();
  if (['ja', 'zh', 'en', 'ja-carecareer', 'ja-compass'].includes(locale)) {
    return locale;
  }
  return 'ja';
}
i18n.global.locale = getCurrentLocale();

import TableKpiPerformances from "./components/manager/kpis/TableKpiPerformances.vue";
import FormQualifications from "./components/manager/users/FormQualifications";
import TableCheckAll from "./components/evaluations/TableCheckAll";
import TableFinalEvaluation from "./components/manager/evaluations/TableFinalEvaluation";
import PersonalGoalsTable from './components/evaluations/PersonalGoalsTable';
import FormEvaluators from "./components/manager/users/FormEvaluators";

if (document.getElementById('kpiPerformances')) {
  Vue.createApp({
    components: {
      TableKpiPerformances,
    }
  }).mount('#kpiPerformances');
}

// スタッフ編集 -> n次評価者の選択フォーム
if (document.getElementById('evaluatorForm')) {
  Vue.createApp({
    components: {
      FormEvaluators
    }
  }).use(i18n)
    .mount('#evaluatorForm');
}

if (document.getElementById('qualificationsForm')) {
  Vue.createApp({
    components: {
      FormQualifications,
    }
  }).use(i18n)
    .mount('#qualificationsForm');
}

if (document.getElementById('checkAll')) {
  Vue.createApp({
    components: {
      TableCheckAll,
    }
  }).use(i18n)
    .mount('#checkAll');
}

if (document.getElementById('finalEvaluation')) {
  Vue.createApp({
    components: {
      TableFinalEvaluation,
    }
  }).use(i18n)
    .mount('#finalEvaluation');
}

if (document.getElementById('personalGoalsTable')) {
  Vue.createApp({
    components: {
      PersonalGoalsTable,
    }
  }).use(i18n)
    .mount('#personalGoalsTable');
}

/**
 * URL中のパラメーターを更新する
 * INFO: https://stackoverflow.com/questions/1090948/change-url-parameters-and-specify-defaults-using-javascript
 *
 * @param url
 * @param param
 * @param paramVal
 * @returns {string}
 */
window.updateURLParameter = function (url, param, paramVal) {
  var TheAnchor = null;
  var newAdditionalURL = "";
  var tempArray = url.split("?");
  var baseURL = tempArray[0];
  var additionalURL = tempArray[1];
  var temp = "";

  if (additionalURL) {
    var tmpAnchor = additionalURL.split("#");
    var TheParams = tmpAnchor[0];
    TheAnchor = tmpAnchor[1];
    if (TheAnchor)
      additionalURL = TheParams;

    tempArray = additionalURL.split("&");

    for (var i = 0; i < tempArray.length; i++) {
      if (tempArray[i].split('=')[0] != param) {
        newAdditionalURL += temp + tempArray[i];
        temp = "&";
      }
    }
  } else {
    var tmpAnchor = baseURL.split("#");
    var TheParams = tmpAnchor[0];
    TheAnchor = tmpAnchor[1];

    if (TheParams)
      baseURL = TheParams;
  }

  if (TheAnchor)
    paramVal += "#" + TheAnchor;

  var rows_txt = temp + "" + param + "=" + paramVal;
  return baseURL + "?" + newAdditionalURL + rows_txt;
}
